/** @jsx jsx */
import { jsx } from '@emotion/react';

import ComplexCollectionComponent from 'bundles/browse-common/components/ComplexCollectionComponent/ComplexCollectionComponent';
import { toComplexCollection } from 'bundles/browse-common/renderers/ComplexCollectionRenderer/toComplexCollection';
import type { PageConfig_ComponentConfig_PageConfig_CollectionComponent_Fragment as PageConfigCollectionComponent } from 'bundles/page-config-common/queries/page-config/__generated__/PageConfigComponentsQuery';

type Props = {
  pageConfig: PageConfigCollectionComponent;
};

const ComplexCollectionRenderer = (props: Props) => {
  const {
    pageConfig: { collectionEntity, secondaryCta },
  } = props;

  if (collectionEntity.__typename !== 'Recommendation_Collection') return null;

  const { first, filters } = toComplexCollection(collectionEntity) ?? {};

  if (!first || !filters) return null;

  return (
    <ComplexCollectionComponent
      title={collectionEntity.description}
      firstCollection={first}
      filters={filters}
      secondaryCta={secondaryCta}
    />
  );
};

export default ComplexCollectionRenderer;
